import React, { Component } from 'react';
import { object } from 'prop-types';
import I18n from '@fiverr-private/fiverr_context/src/I18n';
import {
    buildCategoryNameKey,
    buildNestedSubCategoryNameKey,
    buildSubCategoryNameKey
} from '../../../utils/translation/categories';

import './style.scss';

class Breadcrumbs extends Component {

    getCategoryUrl() {
        const { general, pathfinderWrapper } = this.context;
        const { categorySlug, isPro } = general;
        const path = isPro ? 'short_pro_category' : 'short_category';

        return pathfinderWrapper.pathfinder(path,
            { id: categorySlug },
            { query: { source: 'gig_category_link' } }
        );
    }

    getSubCategoryUrl() {
        const { general, pathfinderWrapper } = this.context;
        const { categorySlug, subCategorySlug, isPro } = general;

        const path = isPro ? 'short_pro_sub_category' : 'short_category_sub_category';

        return pathfinderWrapper.pathfinder(path,
            {
                category_id: categorySlug,
                id: subCategorySlug
            },
            { query: { source: 'gig_sub_category_link' } }
        );
    }

    getNestedSubCategoryUrl() {
        const { pathfinderWrapper, general } = this.context;
        const { categorySlug, subCategorySlug, nestedSubCategorySlug } = general;

        return pathfinderWrapper.pathfinder('short_category_nested_sub_category',
            {
                category_id: categorySlug,
                id: subCategorySlug,
                nested_sub_category_id: nestedSubCategorySlug
            },
            { query: { source: 'gig_nested_sub_category_link' } }
        );
    }

    getProUrl() {
        const { pathfinderWrapper } = this.context;

        return pathfinderWrapper.pathfinder('pro_homepage',
            null,
            { query: { source: 'pro_gig_page' } }
        );
    }

    render() {
        const {
            categoryId,
            subCategoryId,
            nestedSubCategoryId,
            isPro
        } = this.context.general;

        if (!(categoryId && subCategoryId)) {
            return null;
        }

        const showSubCategoryAndCategory = categoryId && subCategoryId;
        const showNestedSubCategory = showSubCategoryAndCategory && nestedSubCategoryId;

        return (
            <nav className="breadcrumbs text-body-2">
                {isPro &&
                <a href={this.getProUrl()}>
                    <I18n k="gig_page_perseus.general.fiverr_pro"/>
                </a>
                }
                {showSubCategoryAndCategory &&
                <a href={this.getCategoryUrl()}>
                    <I18n k={buildCategoryNameKey(categoryId)}/>
                </a>
                }
                {showSubCategoryAndCategory &&
                <a href={this.getSubCategoryUrl()}>
                    <I18n k={buildSubCategoryNameKey(subCategoryId)}/>
                </a>
                }
                {showNestedSubCategory &&
                <a href={this.getNestedSubCategoryUrl()}>
                    <I18n k={buildNestedSubCategoryNameKey(subCategoryId, nestedSubCategoryId)}/>
                </a>
                }
            </nav>
        );
    }
}

Breadcrumbs.contextTypes = {
    general: object,
    pathfinderWrapper: object
};

export default Breadcrumbs;

